var _metadata, _defs, _g, _mask, _g2, _mask2, _g3, _mask3, _g4, _mask4, _g5, _mask5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.12128012694097 69.99999999999994",
    width: 71.12128012694097,
    height: 69.99999999999994,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.89474589679185 10.153268396901922) rotate(0 0.11326711507456366 12.609257599911757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.05 6.07, 0.11 12.15, 0.23 25.22 M0 0 C0.09 10.01, 0.18 20.02, 0.23 25.22",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10.581186056696993) rotate(0 0.11326711507456366 12.609257599911757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.05 5.47, 0.1 10.94, 0.23 25.22 M0 0 C0.09 9.52, 0.17 19.04, 0.23 25.22",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.26442594328364 36.17937541459645) rotate(0 13.680120385559405 11.870653756713011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.58 7.45, 17.17 14.9, 27.36 23.74 M0 0 C10.93 9.48, 21.85 18.96, 27.36 23.74",
    stroke: "#005e79",
    strokeWidth: 4,
    fill: "none"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.103554180920014 35.88576023214023) rotate(0 -11.69155990415095 12.057119883929857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-6.87 7.09, -13.74 14.17, -23.38 24.11 M0 0 C-6.27 6.46, -12.53 12.92, -23.38 24.11",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.17899191153981 10.193425857976877) rotate(0 25.25148694474268 -0.09671292898843831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C19.56 -0.07, 39.12 -0.15, 50.5 -0.19 M0 0 C18.47 -0.07, 36.94 -0.14, 50.5 -0.19",
    stroke: "#e0115f",
    strokeWidth: 4,
    fill: "none"
  })))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePlate);
export default __webpack_public_path__ + "static/media/home-plate.67bd3b2577595c3e5df728d1da620dbc.svg";
export { ForwardRef as ReactComponent };